<template>
  <div class="outer-body">
    <a :href="data.classesUrls[0].url" @click="isIn(data)" target="_blank">
      <div>
        <div class="middle-main">
          <img class="back-img" v-if="data.courseType == 11" :src="`${assetsUrl}imgs/course/middle/middleBack.jpg`">
          <img class="back-img" v-if="data.courseType == 16" :src="`${assetsUrl}imgs/course/middle/cjBack.jpg`">
          <img class="back-img" v-if="data.courseType == 18" :src="`${assetsUrl}imgs/course/middle/swsBack.jpg`">
          <img class="back-img" v-if="data.courseType == 141" :src="`${assetsUrl}imgs/course/middle/cjjjs.png`">
          <img class="back-img" v-if="data.courseType == 142" :src="`${assetsUrl}imgs/course/middle/zjjjs.png`">
          <div v-if="data.courseType!=141 && data.courseType!=142">
            <img class="middle-title" v-if="data.courseType == 11" :src="`${assetsUrl}imgs/course/middle/middleTitle.png`">
            <img class="middle-title" v-if="data.courseType == 16" :src="`${assetsUrl}imgs/course/middle/cjiTitle.png`">
            <img class="middle-title" v-if="data.courseType == 18" :src="`${assetsUrl}imgs/course/middle/swstitle.png`">
            <button>进入</button>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>

export default {
  name: 'MockMacc',
  components: {
  },
  data() {
    return {
        assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
        planclassesId: '',
        classesId: '',
        para: {
        classesId: 'cbfe6de5a8bd19f2a7df1b88985b5155',
        planclassesId: '1375ff50401df0e76f05dac1ad844d6a'
        },
        domain: '1',
        domainData: { courseId: 5 },
        info: '1',
        nextUrl: '1',
        errorMess: '1',
    }
  },
  created() {
    console.log(this.data.courseType)
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: null
    },
  },
  methods: {
    isIn(item) {
    if (item.signUp !== 1 || item.url == null) {
      // item.mess ? this.http.alertMsg('错误信息', item.mess) : ''
      return false
    }
    return true
  }
  },
}
</script>
<style scoped lang="less">
.outer-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.inner-div {
  width: 51.2rem;
  height: 38.4rem;
  background-image: url("#{$assetsUrl}imgs/course/cpa/cpa-cost-back%20.jpg");
  //background-image: url("https://o2o-demo.oss-cn-hangzhou.aliyuncs.com/o2ostu/assets/imgs/course/cpa/cpa-cost-back%20.jpg");
  background-repeat: no-repeat;
  background-size:  100% 100%;
  //background-image: url(assets/imgs/course/cpa-cost-back .jpg) no-repeat;
}
.main-div{
  width: 45.75rem;
  height:23rem;
  background-color: white;
  border-radius: .6rem;
  margin-top: 3.4rem;
  margin-left: 2.7rem;
  box-shadow: 0px 3px 13px rgba(0, 0, 0, .4);
}
button{
  height: 3.3rem;
  width: 15.8rem;
  border: none;
  margin-right: 4rem;
  font-size: 1rem;
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  line-height: 3.3rem;
  outline: none;
}
.able-in:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}

@media (min-height: 750px) and (max-height: 825px){
  .inner-div,.middle-main{
    margin-top: 5rem;
    margin-bottom: 1rem;

  }
}
@media (min-height: 600px) and (max-height: 750px){
  .inner-div,.middle-main{
    margin-top: 8rem;
    margin-bottom: 3rem;
  }
  .middle-main{
    margin-top: 10rem;
  }
}
@media (min-height: 600px) and (max-height: 680px){
  .middle-main{
    margin-top: 15rem;
  }
}
@media screen and (max-height: 600px){
  .inner-div,.middle-main{
    margin-top: 18rem;
  }
}
.middle-main{
  position: relative;
  // width: 51.3rem;
  height: 38.5rem;
  background-color: white;
  border:.05rem solid #E3E3E3;
}
.middle-main button{
  position: absolute;
  top:9rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: white;
  color: #208ca5;
  font-size: 1.1rem;
  box-shadow: 0px 3px 0px #b1dbd9;
}
.middle-main button:hover{
  background-color: #98d172;
  color: white;
  box-shadow:none;
}

.middle-main button:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}
.middle-title{
  width: 21.2rem;
  position: absolute;
  top: -7rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}

</style>
